"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var BanrisulCheckNumberCalculator = /** @class */ (function () {
    function BanrisulCheckNumberCalculator() {
    }
    BanrisulCheckNumberCalculator.calculate = function (accountNumber) {
        var numbers = accountNumber.split("");
        var sumSeq = 0;
        for (var i = 0; i < numbers.length; i++) {
            var n = parseInt(numbers[i]);
            sumSeq += this.multiplyAccordingWeight(n, i);
        }
        return this.moduleEleven(sumSeq).toString();
    };
    BanrisulCheckNumberCalculator.multiplyAccordingWeight = function (n, index) {
        var weight = [3, 2, 4, 7, 6, 5, 4, 3, 2];
        return n * weight[index];
    };
    BanrisulCheckNumberCalculator.moduleEleven = function (sumSeq) {
        var module = sumSeq % 11;
        if (module === 0) {
            return 0;
        }
        else if (module === 1) {
            return 6;
        }
        return 11 - module;
    };
    return BanrisulCheckNumberCalculator;
}());
exports.default = BanrisulCheckNumberCalculator;
//# sourceMappingURL=BanrisulCheckNumberCalculator.js.map